// Hide specific search suggestions - Add this to your theme's JavaScript

document.addEventListener('DOMContentLoaded', function() {
  
  // Terms to hide from search suggestions
  const termsToHide = ['battle figures', 'tcg', 'scarlet'];
  
  // Function to hide unwanted suggestions
  function hideUnwantedSuggestions() {
    // Target the suggestions list
    const suggestionsList = document.querySelector('#predictive-search-results-queries-list');
    
    if (suggestionsList) {
      const suggestions = suggestionsList.querySelectorAll('.predictive-search__list-item');
      let hiddenCount = 0;
      
      suggestions.forEach(function(suggestion) {
        const link = suggestion.querySelector('.predictive-search__item-link');
        const text = suggestion.querySelector('.predictive-search__item-heading');
        
        if (link && text) {
          const suggestionText = text.textContent.toLowerCase().trim();
          
          // Check if this suggestion contains any terms we want to hide
          const shouldHide = termsToHide.some(term => 
            suggestionText.includes(term.toLowerCase())
          );
          
          if (shouldHide) {
            suggestion.style.display = 'none';
            hiddenCount++;
          }
        }
      });
      
      // If all suggestions are hidden, hide the entire suggestions section
      if (hiddenCount === suggestions.length && suggestions.length > 0) {
        const suggestionsSection = suggestionsList.closest('.predictive-search__result-group');
        if (suggestionsSection) {
          suggestionsSection.style.display = 'none';
        }
      }
    }
  }
  
  // Run when search results are loaded
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // Check if predictive search results were added
        const addedNodes = Array.from(mutation.addedNodes);
        const hasSearchResults = addedNodes.some(node => 
          node.nodeType === 1 && 
          (node.id === 'predictive-search-results' || 
           node.querySelector('#predictive-search-results'))
        );
        
        if (hasSearchResults) {
          setTimeout(hideUnwantedSuggestions, 100);
        }
      }
    });
  });
  
  // Start observing
  const searchContainer = document.querySelector('.predictive-search');
  if (searchContainer) {
    observer.observe(searchContainer, {
      childList: true,
      subtree: true
    });
  }
  
  // Also run on page load in case results are already there
  hideUnwantedSuggestions();
});